import React, { useState, useEffect } from "react";
import styles from "./FrequentAskQuestion.module.css";
import { Link } from "react-router-dom";

const faqData = [
  {
    question: "Is my project confidential?",
    answer:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's",
  },
  {
    question: "How do I select an expert?",
    answer:
      "You can browse expert profiles and filter by skills, ratings, or cost.",
  },
  {
    question: "What will be the payment terms?",
    answer:
      "Payment terms are flexible and can be customized based on your agreement.",
  },
  {
    question: "How much does it cost?",
    answer:
      "Pricing depends on project scope, duration, and expert experience.",
  },
  {
    question: "Who owns the Intellectual property (IP)?",
    answer:
      "All IP belongs to the client unless agreed otherwise in the project terms.",
  },
];

const FAQ = ({ role }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [faqData, setFaqData] = useState([]);

  // Fetch FAQ data from API based on role
  useEffect(() => {
    const fetchFAQs = async () => {
      try {
        setLoading(true);
        const baseUrl = process.env.REACT_APP_API_BASE_URL || "https://api.imparc.site/";
        const apiUrl = role 
          ? `${baseUrl}api/faq?cat=${role}`
          : `${baseUrl}api/faq`;
        
        const response = await fetch(apiUrl);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const apiResponse = await response.json();

        // Extract FAQs data from the nested response structure
        if (apiResponse.success && apiResponse.faqs && apiResponse.faqs) {
          // Map the API response to the expected format
          const mappedFAQs = apiResponse.faqs.map(faq => ({
            question: faq.title,
            answer: faq.description,
            id: faq.id,
            category: faq.category
          }));
          
          setFaqData(mappedFAQs);
        } else {
          throw new Error('Invalid API response structure');
        }

        setError(null);
      } catch (err) {
        setError('Failed to load FAQs. Please try again later.');
        console.error('Error fetching FAQs:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchFAQs();
  }, [role]);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  if (loading) {
    return <div className={styles.loading}>Loading FAQs...</div>;
  }

  if (error) {
    return <div className={styles.error}>{error}</div>;
  }

  return (
    <section className={styles.faqSection}>
      <div className={styles.faqList}>
        {faqData?.slice(0, 5).map((item, index) => (
          <div
            key={item.id || index}
            className={`${styles.faqItem} ${
              activeIndex === index ? styles.active : ""
            }`}
            onClick={() => toggleFAQ(index)}
          >
            <div className={styles.question}>
              <span className={styles.questionText}>
                {index + 1}. {item.question}
              </span>
              <span className={styles.faqsicon}>
                {activeIndex === index ? "−" : "+"}
              </span>
            </div>
            <div
              className={`${styles.answer} ${
                activeIndex === index ? styles.open : ""
              }`}
            >
              <div className={styles.answerInner}>{item.answer}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

const FrequentAskQuestion = ({ role }) => {
  return (
    <div className={styles.blueBorderBlock}>
      <div className={styles.heading}>
        <h4>FAQ's</h4>{" "}
        <Link to="/faq" className={styles.viewAll}>
          See All FAQs
        </Link>
      </div>
      <div className={styles.content}>
        <FAQ role={role} />
      </div>
    </div>
  );
};

export default FrequentAskQuestion;
